import { Navigate, Route, Routes } from "react-router-dom";
import AppLayout from "@/layouts/AppLayout";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import DashboardPage from "@/pages/app/DashboardPage";
import LivePage from "@/pages/app/LivePage";
import UsersPage from "@/pages/app/UsersPage";
import ProfilePage from "@/pages/app/ProfilePage";
import DevelopersPage from "@/pages/app/DevelopersPage";
import AppsPage from "@/pages/app/AppsPage";
import InboundPage from "@/pages/app/InboundPage";
import ExtensionsPage from "@/pages/app/ExtensionsPage";
import CdrPage from "@/pages/app/CdrPage";
import BulkCallingPage from "@/pages/app/BulkCallingPage";
import ContactsPage from "@/pages/app/ContactsPage";
import SoftphonePage from "@/pages/app/SoftphonePage";
import ComingSoonPage from "@/pages/app/ComingSoonPage";

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<LoginPage />} />
      <Route path="/register" element={<RegisterPage />} />
      <Route path="/forgot-password" element={<Navigate to="/" replace />} />
      <Route path="/reset-password" element={<Navigate to="/" replace />} />
      <Route path="/app" element={<AppLayout />}>
        <Route index element={<DashboardPage />} />
        <Route path="dial" element={<Navigate to="/app/softphone" replace />} />
        <Route path="softphone" element={<SoftphonePage />} />
        <Route path="live" element={<LivePage />} />
        <Route path="users" element={<UsersPage />} />
        <Route path="extensions" element={<ExtensionsPage />} />
        <Route path="inbound" element={<InboundPage />} />
        <Route path="cdr" element={<CdrPage />} />
        <Route path="bulk" element={<BulkCallingPage />} />
        <Route path="contacts" element={<ContactsPage />} />
        <Route path="apps" element={<AppsPage />} />
        <Route path="developers" element={<DevelopersPage />} />
        <Route path="profile" element={<ProfilePage />} />
        <Route path="docs" element={<Navigate to="/app/developers" replace />} />
        <Route path="clients" element={<Navigate to="/app/contacts" replace />} />
        <Route path="voice" element={<ComingSoonPage title="Voice prompts" />} />
        <Route path="settings/pbx" element={<Navigate to="/app/apps" replace />} />
        <Route path="settings/crm" element={<ComingSoonPage title="CRM hub" />} />
        <Route path="billing" element={<ComingSoonPage title="Subscription" />} />
        <Route path="tenants" element={<Navigate to="/app/apps" replace />} />
        <Route path="widget-demo" element={<ComingSoonPage title="Widget demo" />} />
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
